import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Environment } from 'src/environments/environment.model';

import {
  FmsDiagnoseCropFieldsResponse,
  FmsDiagnoseProvider,
  FmsDiagnoseProviderCustomer,
  FmsDiagnoseResponse,
  FmsDiagnoseSpraysResponse,
} from '../models/fms-diagnose.model';

interface FmsDiagnoseProviderCustomersResponse {
  customers: FmsDiagnoseProviderCustomer[];
}

@Injectable({ providedIn: 'root' })
export class FmsDiagnoseApiService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);
  private readonly baseUrl = `${this.env.APIM_BASE_URL}/arable-advice-service/fms-diagnose`;

  getDiagnose(): Observable<FmsDiagnoseResponse> {
    return this.http.get<FmsDiagnoseResponse>(this.baseUrl);
  }

  getProviderCustomers(
    provider: FmsDiagnoseProvider,
    year: number,
  ): Observable<FmsDiagnoseProviderCustomer[]> {
    return this.http
      .get<FmsDiagnoseProviderCustomersResponse>(`${this.baseUrl}/provider-customers`, {
        params: { provider, year: year.toString() },
      })
      .pipe(map((response) => response.customers));
  }

  getCropFields(): Observable<FmsDiagnoseCropFieldsResponse> {
    return this.http.get<FmsDiagnoseCropFieldsResponse>(`${this.baseUrl}/crop-fields`);
  }

  getSprays(): Observable<FmsDiagnoseSpraysResponse> {
    return this.http.get<FmsDiagnoseSpraysResponse>(`${this.baseUrl}/sprays`);
  }

  triggerFmsSync(): Observable<void> {
    return this.http.post<void>(
      `${this.env.APIM_BASE_URL}/arable-advice-service/fms-sync/trigger`,
      {},
    );
  }
}
